import { Component, Input, OnInit } from '@angular/core';

@Component({
  templateUrl: './occupations-change-final-solution-type-finish.component.html',
})
export class OccupationsChangeFinalSolutionTypeFinishComponent implements OnInit {
  @Input()
  data: any;
  @Input()
  newOperation: Function;
  @Input()
  goToList: Function;

  ngOnInit() {
  }
}
